import { render, staticRenderFns } from "./FindingsTab.vue?vue&type=template&id=11035bf2"
import script from "./FindingsTab.vue?vue&type=script&lang=js"
export * from "./FindingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports